import { ChevronDown, Download, Upload } from "lucide-react";
import { Button } from "@/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/DropdownMenu";
import { cn } from "@/lib/utils";

interface Props {
  canExport: boolean;
  canImport: boolean;
  // Export is a download link (By Month) or a client-side CSV build (By Day).
  exportHref?: string;
  onExport?: () => void;
  onOpenImport: () => void;
  // Absent on pages without a revenue file (By Day).
  onOpenImportRevenue?: () => void;
  // Extra classes for the Actions trigger (the tab row squares it off).
  buttonClassName?: string;
}

export default function ByMonthToolbarActions({
  canExport,
  canImport,
  exportHref,
  onExport,
  onOpenImport,
  onOpenImportRevenue,
  buttonClassName,
}: Props) {
  const hasActions = canImport || canExport;
  if (!hasActions) return null;

  return (
    <div className="flex h-full items-stretch gap-2">
      <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="outline"
              size="sm"
              className={cn("h-full focus-visible:ring-0 focus-visible:ring-offset-0", buttonClassName)}
            >
              Actions
              <ChevronDown className="ml-1.5 h-3.5 w-3.5 text-muted-foreground" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="min-w-[14rem]">
            {canImport && (
              <DropdownMenuItem onSelect={onOpenImport}>
                <Upload className="mr-2 h-3.5 w-3.5 text-muted-foreground" />
                Import Quantity CSV…
              </DropdownMenuItem>
            )}
            {canImport && onOpenImportRevenue && (
              <DropdownMenuItem onSelect={onOpenImportRevenue}>
                <Upload className="mr-2 h-3.5 w-3.5 text-muted-foreground" />
                Import Revenue CSV…
              </DropdownMenuItem>
            )}
            {canExport && onExport && (
              <DropdownMenuItem onSelect={onExport}>
                <Download className="mr-2 h-3.5 w-3.5 text-muted-foreground" />
                Export CSV
              </DropdownMenuItem>
            )}
            {canExport && !onExport && exportHref && (
              <DropdownMenuItem asChild>
                <a href={exportHref}>
                  <Download className="mr-2 h-3.5 w-3.5 text-muted-foreground" />
                  Export CSV
                </a>
              </DropdownMenuItem>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
    </div>
  );
}
